export function ViewChild(selector: string): PropertyDecorator {
  return (target: Object, propertyKey: string): void => {
    Object.defineProperty(target.constructor.prototype, propertyKey, {
      get: function(): HTMLElement | undefined {
        return this['querySelector'](selector);
      },
    });
  };
}
